import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
// import 'prismjs/themes/prism.css';
// import 'prismjs/themes/prism-okaidia.css';
// import 'prismjs/themes/prism-twilight.css';
// import 'prismjs/themes/prism-solarizedlight.css';
// import asyncComponent from '../AsyncComponent';
import Headline from '../Article/Headline';
import Bodytext from '../Article/Bodytext';
import Meta from './Meta';
import Author from '../Footer/Author';
// import CommentsDisqus from './CommentsDisqus';
import NextPrev from './NextPrev';
import Share from './Share';
import { css } from '@linaria/core';
import { styled } from '@linaria/react';
// import { ScreenWidthContext } from '../../layouts/Layout';
import { insertScript, removeScript, getScreenWidth } from '../../utils/helpers';
import likeCoinGif from '../../images/like-coin/Liking_Text2.gif';

// there is a bug in react rendering when import share component asynchronously
// const Share = asyncComponent(() =>
//   import('./Share')
//     .then(module => {
//       return module.default;
//     })
//     .catch(error => {})
// );

const Post = (props) => {
  const {
    post,
    post: {
      html,
      fields: { prefix, slug },
      frontmatter: {
        showPostTitle,
        title,
        datePublished,
        dateModified,
        author,
        category,
        tags,
        coverHero,
        cover,
      },
    },
    authorNote,
    disqus,
    next: nextPost,
    prev: prevPost,
    theme,
  } = props;

  // const screenWidth = useContext(ScreenWidthContext);
  const screenWidth = getScreenWidth();
  // Pixel 3 will change JS screen.width to 786px when change to landscape used 540px as threshold to reduce wide
  // use width 455px for width wider than 540px
  // const fbPagePluginWidth = screenWidth <= 540 ? 340 : 455;
  const fbPagePluginWidth = 340;
  const fbPluginURL = `https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fwholovetravel&tabs&width=${fbPagePluginWidth}&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=false&appId=1043352130696900`;
  // console.log('fbPagePluginWidth', fbPagePluginWidth);
  // console.log('screenWidth', screenWidth);
  const agodaSearchBarTypeIsWide = screenWidth >= 1230;
  // let agodaSearchBarId = agodaSearchBarTypeIsWide ? 'adgshp-1481699128' : 'adgshp1683589233';
  // let agodaSearchBarId = '';
  const isTahiti = tags.includes('大溪地') || tags.includes('波拉波拉島') || tags.includes('茉莉亞島');
  const isBali = tags.includes('峇里島自由行');
  const isPhuQuoc = tags.includes('越南富國島');
  const isDubai = tags.includes('杜拜自由行');
  const hasDestination = isTahiti || isBali || isPhuQuoc || isDubai;
  // if (hasDestination) {
  //   if (isTahiti && agodaSearchBarTypeIsWide) {
  //     agodaSearchBarId = 'adgshp-1481699128';
  //   } else if (isTahiti && !agodaSearchBarTypeIsWide) {
  //     agodaSearchBarId = 'adgshp1683589233';
  //   } else if (isBali && agodaSearchBarTypeIsWide) {
  //     agodaSearchBarId = 'adgshp2059059477';
  //   } else if (isBali && !agodaSearchBarTypeIsWide) {
  //     agodaSearchBarId = 'adgshp273324836';
  //   } else if (isPhuQuoc && agodaSearchBarTypeIsWide) {
  //     agodaSearchBarId = 'adgshp-1610192568';
  //   } else if (isPhuQuoc && !agodaSearchBarTypeIsWide) {
  //     agodaSearchBarId = 'adgshp558771283';
  //   } else if (isDubai && agodaSearchBarTypeIsWide) {
  //     agodaSearchBarId = 'adgshp-1994283013';
  //   } else if (isDubai && !agodaSearchBarTypeIsWide) {
  //     agodaSearchBarId = 'adgshp2108581510';
  //   }
  // } else {
  //   if (agodaSearchBarTypeIsWide) {
  //     agodaSearchBarId = 'adgshp2099854641';
  //   } else agodaSearchBarId = 'adgshp1694537125';
  // }

  // useEffect(() => {
  //   if (typeof window !== 'undefined') {
  //     // load3rdPartyScript(category); //remove agoda search bar
  //     // console.log('useEffect post mount:', props);
  //   }
  //   return () => {
  //     if (typeof window !== 'undefined') {
  //       // console.log('useEffect post unmount:', props);
  //       // remove3rdPartyScript(category); //remove agoda search bar
  //     }
  //   };
  // }, []);

  const load3rdPartyScript = (cat) => {
    const doc = window.document;
    // console.log('post screenWidth load3rdPartyScript:', screenWidth);
    if (cat === '旅行日誌') {
      // klook script
      // insertScript(
      //   'https://cdn.klook.com/s/dist_web/klook-affiliate-front/static/widget/iframe/iframe-init-v1.0.10.js',
      //   'klook-search-scr',
      //   doc.body
      // );
      // airbnb script
      // insertScript('https://www.airbnb.com.tw/embeddable/airbnb_jssdk', 'airbnb-scr', doc.body);

      if (hasDestination) {
        let crt = '';
        let stgId = '';
        let referenceKey = '';
        let city = '';
        let destinationName = '';
        let width = '';
        let height = '';
        let layout = '';
        if (isTahiti && agodaSearchBarTypeIsWide) {
          crt = '8930565373479';
          stgId = 'adgshp-1481699128';
          referenceKey = 'WWI0kzR5IbumP6Qpv9n2SA==';
          city = '102632';
          destinationName = '大溪地, 法屬玻里尼西亞';
          width = '1187px';
          height = '340px';
          layout = 'Oneline';
        } else if (isTahiti && !agodaSearchBarTypeIsWide) {
          crt = '8930703502395';
          stgId = 'adgshp1683589233';
          referenceKey = 'L9z1WIRATJRhWVMZ5bpzdQ==';
          city = '102632';
          destinationName = '大溪地, 法屬玻里尼西亞';
          width = '308px';
          height = '406px';
          layout = 'SquareCalendar';
        } else if (isBali && agodaSearchBarTypeIsWide) {
          crt = '8932780674337';
          stgId = 'adgshp2059059477';
          referenceKey = 'FbRDd1Z4QF8dw9sIWyP6JA==';
          city = '17193';
          destinationName = '峇里島, 印尼';
          width = '1187px';
          height = '340px';
          layout = 'Oneline';
        } else if (isBali && !agodaSearchBarTypeIsWide) {
          crt = '8932939034600';
          stgId = 'adgshp273324836';
          referenceKey = 'A9cGGiOFKgvNMSKABow/7w==';
          city = '17193';
          destinationName = '峇里島, 印尼';
          width = '308px';
          height = '406px';
          layout = 'SquareCalendar';
        } else if (isPhuQuoc && agodaSearchBarTypeIsWide) {
          crt = '8934404412470';
          stgId = 'adgshp-1610192568';
          referenceKey = 'AuKGdjNZSs1IwrChtSUAbw==';
          city = '17188';
          destinationName = '富國島, 越南';
          width = '1187px';
          height = '340px';
          layout = 'Oneline';
        } else if (isPhuQuoc && !agodaSearchBarTypeIsWide) {
          crt = '8933764425813';
          stgId = 'adgshp558771283';
          referenceKey = 'vGUGOFRd6PmoWJDnG2n1CA==';
          city = '17188';
          destinationName = '富國島, 越南';
          width = '308px';
          height = '406px';
          layout = 'SquareCalendar';
        } else if (isDubai && agodaSearchBarTypeIsWide) {
          crt = '8936992044740';
          stgId = 'adgshp-1994283013';
          referenceKey = 'iiAvqFVoUyInsnFR32yDCg==';
          city = '2994';
          destinationName = '杜拜, 阿拉伯聯合大公國';
          width = '1187px';
          height = '340px';
          layout = 'Oneline';
        } else if (isDubai && !agodaSearchBarTypeIsWide) {
          crt = '8936553336839';
          stgId = 'adgshp2108581510';
          referenceKey = 'NgP8KuEI4bDgeMPdLwkK0w==';
          city = '2994';
          destinationName = '杜拜, 阿拉伯聯合大公國';
          width = '308px';
          height = '406px';
          layout = 'SquareCalendar';
        }
        insertScript(
          `var stg = new Object();
           stg.crt="${crt}";
           stg.version="1.04";
           stg.id=stg.name="${stgId}";
           stg.width="${width}";
           stg.height="${height}";
           stg.ReferenceKey="${referenceKey}";
           stg.Layout="${layout}";
           stg.Language="zh-tw";
           stg.Cid="1881633";
           stg.City="${city}";
           stg.DestinationName="${destinationName}";
           stg.OverideConf=false;
           new AgdSherpa(stg).initialize();`,
          'agoda-search-scr-txt',
          doc.body,
          'text/javascript'
        );
      } else {
        let crt = '';
        let stgId = '';
        let referenceKey = '';
        let width = '';
        let height = '';
        let layout = '';
        if (agodaSearchBarTypeIsWide) {
          crt = '8916866324789';
          stgId = 'adgshp2099854641';
          referenceKey = 'gc8iXxC913GK/Ty1OTzPiw==';
          width = '1187px';
          height = '340px';
          layout = 'Oneline';
        } else {
          crt = '8916052910455';
          stgId = 'adgshp1694537125';
          referenceKey = 'Tpbb8hTNeWtl3RpXT2jLuA==';
          width = '308px';
          height = '406px';
          layout = 'SquareCalendar';
        }
        insertScript(
          `var stg = new Object();
             stg.crt="${crt}";
             stg.version="1.04";
             stg.id=stg.name="${stgId}";
             stg.width="${width}";
             stg.height="${height}";
             stg.ReferenceKey="${referenceKey}";
             stg.Layout="${layout}";
             stg.Language="zh-tw";
             stg.Cid="1881633";
             stg.DestinationName="";
             stg.OverideConf=false;
             new AgdSherpa(stg).initialize();`,
          'agoda-search-scr-txt',
          doc.body,
          'text/javascript'
        );
      }
    }
  };

  const remove3rdPartyScript = (cat) => {
    const doc = window.document;
    if (cat === '旅行日誌') {
      removeScript('agoda-search-scr-txt', doc.body);
      // removeScript('airbnb-scr', doc.body);
    }
  };

  let heroBgMobile;
  if (coverHero) {
    heroBgMobile = coverHero?.childImageSharp?.heroImageBgMobile?.src ?? '';
  } else {
    heroBgMobile = cover?.childImageSharp?.heroImageBgMobile?.src ?? '';
  }

  // const likeButtonURL = `https://button.like.co/in/embed/fabulous-lifestyles/button?referrer=https://wholovetravel.com${slug}`;
  // console.debug('likeButtonURL', likeButtonURL);
  // like coin referral https://liker.land/civic?from=fabulous-lifestyles
  return (
    <React.Fragment>
      <header>
        {showPostTitle ? <Headline title={title} theme={theme} /> : null}
        <Meta
          slug={slug}
          title={title}
          datePublished={datePublished}
          dateModified={dateModified}
          author={author}
          category={category}
          tags={tags}
          disqus={disqus}
          theme={theme}
        />
      </header>
      <Bodytext html={html} theme={theme} />
      <section className={adSection}>
        {/* {slug.includes('tahiti-dream-lagoon-villa') ? (
          <>
            <h3 style={{ alignSelf: 'center' }}>
              還未加入 Airbnb 嗎？
              <a
                href="https://www.airbnb.com.tw/c/kchen236?referral_share_id=9a654807-cabf-49e1-ad32-cac35a3a8440"
                target="_blank"
                rel="noopener"
              >
                現在『點我』加入首趟旅程可獲取 $1,900+ TWD 旅行基金優惠喔！
              </a>
            </h3>
            <div
              className="airbnb-embed-frame"
              data-view="a4p_memento_embeddable"
              data-id="27811"
              data-width="500"
              style={{ width: '500px', alignSelf: 'center', marginBottom: '3em' }}
            />
          </>
        ) : null}
        {slug.includes('tahiti-saving-tips') || slug.includes('moorea-attractions') ? (
          <>
            <h3 style={{ alignSelf: 'center' }}>
              還未加入 Airbnb 嗎？
              <a
                href="https://www.airbnb.com.tw/c/kchen236?referral_share_id=9a654807-cabf-49e1-ad32-cac35a3a8440"
                target="_blank"
                rel="noopener"
                className="externalLink"
              >
                現在『點我』加入首趟旅程可獲取 $1,900+ TWD 旅行基金優惠喔！
              </a>
            </h3>
            <div
              className="airbnb-embed-frame"
              data-view="a4p_event_embeddable"
              data-id="27847"
              data-height="690"
              style={{ height: '690px', marginBottom: '3em' }}
            />
          </>
        ) : null} */}
        {/* <p className={articleEndDescription}>
          感謝你耐心地看到最後 😊 如果您喜歡我們的文章，或如果這篇文章對您有幫助，歡迎在下面 👇🏻 的『拍手讚賞鍵』👏🏼{' '}
          幫忙按下 👏🏻！就可以化讚為賞，免費贊助！感謝您對這篇文章的正向回饋，支持創作。謝謝您！
        </p>
        <img
          alt="like-coin-description"
          src={likeCoinGif}
          loading="lazy"
          className={likeGIF}
          style={{ alignSelf: 'center' }}
        ></img>
        <LikecoinButton className="likecoin-embed">
          <iframe
            loading="lazy"
            scrolling="no"
            frameBorder="0"
            sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            style={{ height: '212px', width: '100%', overflow: 'hidden' }}
            src={likeButtonURL}
          ></iframe>
        </LikecoinButton>
        <p className={articleEndDescription}>
          如果喜歡我們的文章，記得把『誰都愛旅行』加入書籤，網站內容會不定期更新，有空歡迎常回來逛逛唷！你的支持是我們繼續寫作的原動力
          🙏🏻！最新影片和文章連結都會隨時更新在 FB 粉絲專頁及 Youtube 頻道，記得訂閱分享按讚 👍🏼，還有小鈴鐺 🔔 喔!!
        </p> */}
        <div style={{ textAlign: 'center' }}>
          <iframe
            loading="lazy"
            src={fbPluginURL}
            width={fbPagePluginWidth}
            height="130"
            style={{ border: 'none', overflow: 'hidden' }}
            scrolling="no"
            frameBorder="0"
            allowtransparency="true"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          />
        </div>
      </section>
      <footer>
        <Share post={post} theme={theme} previewImgSelfHost={heroBgMobile} />
        <Author author={author} note={authorNote} theme={theme} />
        <NextPrev nextMarkdownPost={nextPost} prevMarkdownPost={prevPost} theme={theme} />
        {/* <section className={adSection}> */}
        {/* <div id={agodaSearchBarId} className={agodaSearch} /> */}
        {/* <div id="adgshp1683589233" className="agodaSearch" />
          <div id="adgshp-1481699128" className="agodaSearch" /> */}
        {/* </section> */}
        {/* <CommentsDisqus title={title} slug={slug} disqus={disqus} /> */}
      </footer>
    </React.Fragment>
  );
};

Post.propTypes = {
  post: PropTypes.object.isRequired,
  authorNote: PropTypes.string.isRequired,
  // facebook: PropTypes.object.isRequired,
  disqus: PropTypes.object.isRequired,
  next: PropTypes.object,
  prev: PropTypes.object,
  theme: PropTypes.object.isRequired,
};

export default Post;

const adSection = css`
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  margin-bottom: 30px;
`;

const agodaSearch = css`
  align-self: center;
`;

const LikecoinButton = styled.div`
  align-self: center;
  width: 100%;
  max-width: 485px;
  max-height: 240px;

  & > div {
    padding-top: 49.48454%;
  }
  & > iframe {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const likeGIF = css`
  width: 50%;
  max-width: 100%;
  max-height: 60vh;
  object-fit: contain;
`;

const articleEndDescription = css`
  font-size: 1.2em;
  line-height: 1.7;
  margin-bottom: 1.5em;
`;
